var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as dayjs from 'dayjs';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Table from '@/common/components/Table/oldIndex.vue';
import { refactorCalendars, getPopoverOffset, collectDatesByStartAndEnd, beforeSubmit, refactorSingleClueHandle } from '../../utils';
import MonthSection from '@views/schedule/components/Calendar/MonthSection.vue';
import BoothPopover from '@views/schedule/components/Calendar/BoothPopover.vue';
import AddClueDialog from './AddClueDialog.vue';
import Empty from '@views/schedule/components/Calendar/Empty.vue';
import { dateFns, deepCopy } from '@lhb/func';
import ElTableInfiniteScroll from 'el-table-infinite-scroll';
// @ts-ignore
var Month = /** @class */ (function (_super) {
    __extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calendars = [];
        _this.lastShopName = '';
        _this.hoverColumnIndex = 0;
        _this.infiniteDisable = true;
        _this.isSelecting = false;
        _this.selected = {
            boothInfo: {
                id: null,
            },
            dates: [],
            sort: null,
            startAt: null,
            endAt: null,
            month: null,
        };
        _this.showAddClueDialog = false;
        _this.curSelectLayout = {
            x: 0,
            y: 0,
            initY: 0,
            scrollY: 0,
        };
        _this.today = new Date();
        _this.todayStr = dateFns.changeTime(new Date(), null, true);
        return _this;
    }
    Object.defineProperty(Month.prototype, "currentMonths", {
        get: function () {
            var _a = this.searchParams, startDate = _a.startDate, endDate = _a.endDate;
            var months = dayjs(endDate).diff(dayjs(startDate), 'month') + 1;
            var monthOptions = [];
            for (var i = 0; i < months; i++) {
                var currentMonth = dayjs(startDate).add(i, 'month');
                monthOptions.push({
                    label: currentMonth.format('YYYY-MM-DD'), value: +currentMonth.format('MM')
                });
            }
            return monthOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Month.prototype, "tableColumns", {
        get: function () {
            var columns = [{ slotName: 'name', label: '点位名称', minWidth: 80, resizable: false }];
            this.currentMonths.forEach(function (item, index) {
                columns.push({ slotName: item.label, label: item.value + "\u6708", minWidth: 40, resizable: false, index: index + 1 });
            });
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Month.prototype.dataChange = function (newVal) {
        var _this = this;
        var _a;
        var shopName = this.searchParams.offset > 0 ? this.lastShopName : '';
        var calendarData = refactorCalendars({ records: newVal, type: 'month', minDate: this.searchParams.startDate, maxDate: this.searchParams.endDate, shopName: shopName });
        var data = (_a = calendarData === null || calendarData === void 0 ? void 0 : calendarData.data) === null || _a === void 0 ? void 0 : _a.map(function (e, index) { return (__assign(__assign({}, e), { index: _this.searchParams.offset + index, selectedMonth: null })); });
        if (this.searchParams.offset > 0) {
            this.calendars = __spreadArrays(this.calendars, data);
        }
        else {
            this.calendars = data;
        }
        this.lastShopName = calendarData.shopName;
        setTimeout(function () {
            _this.$emit('update:tableLoading', false);
            var hasMore = _this.searchParams.offset + _this.searchParams.limit > _this.total;
            _this.infiniteDisable = hasMore;
        }, 500);
    };
    /* methods */
    Month.prototype.arraySpanMethod = function (_a) {
        var row = _a.row, columnIndex = _a.columnIndex;
        if (!row.id) {
            if (columnIndex === 0) {
                var _b = this.searchParams, startDate = _b.startDate, endDate = _b.endDate;
                var monthDiff = dayjs(endDate).diff(dayjs(startDate), 'month');
                console.log("monthDiff = ", monthDiff);
                return [1, monthDiff + 2];
            }
            else {
                return [0, 0];
            }
        }
    };
    Month.prototype.headerCellClassName = function (_a) {
        var columnIndex = _a.columnIndex;
        if (!columnIndex)
            return '';
        if (columnIndex === this.hoverColumnIndex) {
            return 'column-hover';
        }
        return '';
    };
    Month.prototype.cellMouseEnter = function (_, __) {
        var columnIndex = __.index; // 获取列索引
        this.hoverColumnIndex = columnIndex;
    };
    Month.prototype.cellMouseLeave = function () {
        this.hoverColumnIndex = 0;
    };
    Month.prototype.selectHandle = function (row, month, index, e) {
        var _this = this;
        console.log("row, month", row, month, this.selected);
        var currentDate = dayjs(month.label);
        var startMonth = currentDate.format('YYYY-M');
        var endMonth = currentDate.format('YYYY-M');
        var startAt = currentDate.format('YYYY-MM-01');
        var needReset = true;
        console.log("startMonth = ", startMonth, endMonth);
        var endAt = currentDate.endOf('month').format('YYYY-MM-DD');
        var endDate = currentDate.endOf('month');
        if (this.isSelecting && this.selected.sort === index) {
            console.log("this.selected = ", this.selected);
            var curEndAt = dayjs(this.selected.endAt).format('YYYY-MM-DD');
            var curEndDate = dayjs(this.selected.endAt).endOf('month');
            if (this.selected.month.indexOf(month) > -1)
                return this.cancelSelected();
            if (endDate < curEndDate) {
                endAt = curEndAt;
                endMonth = this.selected.month[1];
            }
            else {
                startAt = dateFns.changeTime(this.selected.startAt, '/', true);
                startMonth = this.selected.month[0];
                needReset = false;
            }
            this.isSelecting = false;
        }
        else {
            this.isSelecting = true;
        }
        var selected = {
            sort: index,
            boothInfo: __assign({}, row),
            dates: collectDatesByStartAndEnd(startAt, endAt),
            startAt: dateFns.changeTime(startAt, null, true),
            endAt: dateFns.changeTime(endAt, null, true),
            month: [startMonth, endMonth],
        };
        return beforeSubmit(selected, function () {
            _this.setSelected(selected);
            needReset && _this.setAddClueDialog(e);
        }, function () {
            _this.$message.warning(dateFns.changeTime(startAt, '.', true) + "-" + dateFns.changeTime(endAt, '.', true) + "\u6863\u671F\u5DF2\u6EE1\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9");
            _this.cancelSelected();
        });
    };
    Month.prototype.setSelected = function (selected) {
        var sort = this.selected.sort;
        if (sort !== null) {
            this.calendars[sort].selectedMonth = null;
        }
        this.selected = __assign({}, selected);
        var curSort = selected.sort;
        if (curSort !== null) {
            console.log("selected.month = ", selected.month);
            this.calendars[curSort].selectedMonth = selected.month;
        }
    };
    Month.prototype.tableScrollHandle = function () {
        var bodyDom = document.getElementsByClassName('el-table__body-wrapper')[0];
        var offset = bodyDom.scrollTop - this.curSelectLayout.scrollY;
        this.curSelectLayout.y = Math.min(Math.max(this.curSelectLayout.initY - offset, 60), bodyDom.clientHeight + 60 - 287);
    };
    Month.prototype.setAddClueDialog = function (e) {
        var table = this.$refs.tableWrap;
        var layout = getPopoverOffset(e, table.offsetTop, table.offsetLeft);
        var bodyDom = document.getElementsByClassName('el-table__body-wrapper')[0];
        this.curSelectLayout = __assign(__assign({}, layout), { scrollY: bodyDom.scrollTop, initY: layout.y });
        this.showAddClueDialog = true;
        if (bodyDom.scrollHeight > bodyDom.clientHeight) {
            bodyDom.addEventListener('scroll', this.tableScrollHandle); // 监听滚动事件
        }
    };
    Month.prototype.updateSelected = function (e) {
        if (e && e.length > 0) {
            var dates = collectDatesByStartAndEnd(new Date(e[0]), new Date(e[1]));
            this.selected.dates = dates;
            this.selected.startAt = e[0];
            this.selected.endAt = e[1];
            if (e[0].indexOf(this.searchParams.year) > -1) {
                this.calendars[this.selected.sort].selectedMonth = e === null || e === void 0 ? void 0 : e.map(function (item) { return new Date(item).getMonth() + 1; });
            }
            else {
                this.calendars[this.selected.sort].selectedMonth = null;
            }
            this.isSelecting = false;
        }
    };
    Month.prototype.cancelSelected = function () {
        this.setSelected({
            sort: null,
            boothInfo: null,
            dates: [],
            startAt: null,
            endAt: null,
            month: null,
        });
        this.isSelecting = false;
        this.showAddClueDialog = false;
        var bodyDom = document.getElementsByClassName('el-table__body-wrapper')[0];
        bodyDom.removeEventListener('scroll', this.tableScrollHandle); // 注销滚动事件
    };
    Month.prototype.refreshHandle = function (item, index) {
        console.log("refreshHandle = \u8FDB\u6765\u4E86", item, index);
        var sort = index || this.selected.sort;
        var startAt = item.startAt, endAt = item.endAt;
        var minDate = this.searchParams.startDate;
        var maxDate = this.searchParams.endDate;
        var minStamp = new Date(minDate).getTime();
        var maxStamp = new Date(maxDate).getTime();
        var startStamp = new Date(startAt).getTime();
        var endStamp = new Date(endAt).getTime();
        if (endStamp < minStamp || startStamp > maxStamp) {
            return this.cancelSelected();
        }
        var record = refactorSingleClueHandle(item, deepCopy(this.calendars[sort]));
        var refactorRecord = refactorCalendars({ records: [record], type: 'month', minDate: this.searchParams.startDate, maxDate: this.searchParams.endDate });
        this.calendars[sort] = refactorRecord.data[refactorRecord.data.length - 1];
        this.cancelSelected();
        // this.$emit('refresh');
    };
    Month.prototype.loadCalendarData = function () {
        if (this.infiniteDisable)
            return;
        this.infiniteDisable = true;
        this.$emit('loadmore');
    };
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Month.prototype, "data", void 0);
    __decorate([
        Prop({ type: Object, default: function () { } })
    ], Month.prototype, "meta", void 0);
    __decorate([
        Prop({ type: Number, default: 0 })
    ], Month.prototype, "total", void 0);
    __decorate([
        Prop({ type: Object, default: function () { } })
    ], Month.prototype, "searchParams", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], Month.prototype, "tableLoading", void 0);
    __decorate([
        Watch('data', {
            deep: true,
        })
    ], Month.prototype, "dataChange", null);
    Month = __decorate([
        Component({
            components: {
                Table: Table,
                BoothPopover: BoothPopover,
                MonthSection: MonthSection,
                AddClueDialog: AddClueDialog,
                Empty: Empty,
            },
            directives: {
                'el-table-infinite-scroll': ElTableInfiniteScroll,
            },
        })
    ], Month);
    return Month;
}(Vue));
export default Month;
